import ThumbnailControls from './ThumbnailControls';

export default ThumbnailControls;
